<template>
  <div class="home" :class="{'skip-intro-animation': isAuthCallback}">
    <div class="head_logo">
      <img src="@/assets/index_logo_image.png" alt="">
    </div>
    <div class="time_area">
      <img src="@/assets/index_time_area.png" alt="">
    </div>
    <audio id="audioPlayer" ref="audio" style="display: none;">
      <source src="http://cauc-anniversary.oss-cn-zhangjiakou.aliyuncs.com/static/zgmhdxxg.mp3" type="audio/mpeg">
    </audio>
    <div class="btns">
      <img class="sound" :src="isPlaying?require('@/assets/sound_icon.png'):require('@/assets/no_sound_icon.png')" alt="" @click="handleSound">
      <img class="message" src="@/assets/message_icon.png" alt="" @click="openMessage">
    </div>
    <img class="index_seven_image" src="@/assets/index_seven_image.png" alt="">
    <img class="index_five_image" src="@/assets/index_five_image.png" alt="">
    <img class="index_yanhua1_image" src="@/assets/index_yanhua1_image.png" alt="">
    <img class="index_yanhua2_image" src="@/assets/index_yanhua2_image.png" alt="">
    <img class="index_yanhua3_image" src="@/assets/index_yanhua3_image.png" alt="">
    <img class="index_line_image" src="@/assets/index_line_image.png" alt="">
    <img class="index_plane_image" src="@/assets/index_plane_image.png" alt="">
    <img @click="lightAction" class="index_light_image" src="@/assets/index_light_image.png" alt="">
    <img class="index_light_des_image" src="@/assets/index_light_des_image.png" alt="">
    <message-dialog v-model="showM"></message-dialog>
    <!--<van-overlay :show="showMask">-->
      <!--<div class="wrapper" @click.stop>-->
        <!--<div class="mask">-->
          <!--<img src="../../assets/mask.gif" alt="">-->
        <!--</div>-->
      <!--</div>-->
    <!--</van-overlay>-->
  </div>
</template>

<script>
import {auth} from '../../utils/ajaxInterface'
import MessageDialog from '../message'
const TARGET = require('../../utils/target')
export default {
  name: 'Home',
  components: {MessageDialog},
  computed: {
    isAuthCallback () {
      return Boolean(this.getQueryParam('code'))
    }
  },
  data () {
    return {
      // showMask: true,
      // 音频是否正在播放的状态
      isPlaying: false,
      TARGET: TARGET,
      showM: false
    }
  },
  mounted () {
    const code = this.getQueryParam('code')
    if (code) {
      // this.showMask = false
      // 发送code到后端获取用户信息
      auth({code}).then(r => {
        localStorage.setItem('userInfo', JSON.stringify(r))
        if (r.status) {
          this.$router.push('/map')
        } else {
          this.$router.push('/form')
        }
      })
    } else {
      // this.showMask = true
      // setTimeout(() => {
      //   this.showMask = false
      // }, 1000)
    }
  },
  methods: {
    handleSound () {
      // 获取音频元素引用
      const audio = this.$refs.audio
      // 根据当前播放状态执行操作
      if (this.isPlaying) {
        // 若正在播放 → 暂停音频
        audio.pause()
      } else {
        // 若未播放 → 开始播放音频
        audio.play()
      }

      // 更新播放状态
      this.isPlaying = !this.isPlaying
    },
    openMessage () {
      this.showM = true
    },
    getQueryParam (name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
      const r = window.location.search.substr(1).match(reg)
      return r ? decodeURIComponent(r[2]) : null
    },
    lightAction () {
      const redirectUri = encodeURIComponent(window.location.href.split('?')[0])
      // const redirectUri = encodeURIComponent('http://test-mobile-cauc-anniversary.sayeasytech.com')
      const scope = 'snsapi_userinfo'
      window.location.href =
              `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.TARGET.APPID}` +
              `&redirect_uri=${redirectUri}&response_type=code&scope=${scope}` +
              `&state=STATE#wechat_redirect`
    }
  }
}
</script>
<style lang="less" scoped>
    .home{
      background: url("../../assets/mhdx.png") no-repeat center center;
      background-size:cover;
      height: 100vh;
      position: relative;
      padding-top: 26px;
      box-sizing: border-box;
      overflow: hidden;
      .head_logo,
      .time_area,
      .btns,
      .index_line_image,
      .index_light_image,
      .index_light_des_image{
        opacity: 0;
        animation: delayed-show 0s linear .3s forwards;
      }
      .head_logo{
        width: 324px;
        height: 106px;
        margin: 0 auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .time_area{
        width: 104px;
        height: 24px;
        margin-top:86px;
        margin-left: 20px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .index_seven_image{
        animation: slide-in-left 0.8s ease-out both;
        position: absolute;
        left: -10px;
        top: 150px;
        width: 251px;
        height: 485px;
        z-index: 4;
      }
      .index_five_image{
        animation: slide-in-right 0.8s ease-out both;
        position: absolute;
        right: -4px;
        top: 250px;
        width: 240px;
        height: 373px;
        z-index: 2;
      }
      .index_yanhua1_image{
        animation: fireworks-show 0.3s ease-out forwards;
        transform: scale(0);
        transform-origin: center center;
        position: absolute;
        left: 100px;
        top: 170px;
        width: 50px;
        height: 50px;
        z-index: 5;
      }
      .index_yanhua2_image{
        animation: fireworks-show 0.3s ease-out forwards;
        transform: scale(0);
        transform-origin: center center;
        position: absolute;
        left: 2px;
        top: 330px;
        width: 76px;
        height: 76px;
        z-index: 5;
      }
      .index_yanhua3_image{
        animation: fireworks-show 0.3s ease-out forwards;
        transform: scale(0);
        transform-origin: center center;
        position: absolute;
        right: -10px;
        top: 150px;
        width: 68px;
        height: 99px;
        z-index: 5;
      }
      .index_line_image{
        position: absolute;
        left:50%;
        transform: translate(-180px);
        top: 400px;
        width: 327px;
        height: 184px;
        z-index: 3;
      }
      .index_plane_image{
        animation: slide-in-plane 1.2s ease-out both;
        position: absolute;
        right:-6px;
        top: 460px;
        width: 239px;
        height: 173px;
        z-index: 4;
      }
      .btns{
        width: 56px;
        position: absolute;
        right: 14px;
        top: 20px;
        display: flex;
        justify-content: space-between;
        .sound,.message{
          width: 24px;
          height: 24px;
        }
      }
      .index_light_image{
        width: 286px;
        height: 55px;
        position: absolute;
        bottom: 60px;
        left: 50%;
        transform: translateX(-143px);
        z-index: 5;
      }
      .index_light_des_image{
        width: 198px;
        height: 20px;
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-99px);
        z-index: 5;
      }
      &.skip-intro-animation{
        .head_logo,
        .time_area,
        .btns,
        .index_line_image,
        .index_light_image,
        .index_light_des_image{
          opacity: 1;
          animation: none;
        }
        .index_seven_image,
        .index_five_image,
        .index_plane_image{
          animation: none;
        }
        .index_yanhua1_image,
        .index_yanhua2_image,
        .index_yanhua3_image{
          animation: none;
          transform: scale(1);
        }
      }
    }
    @keyframes delayed-show {
      to {
        opacity: 1;
      }
    }
    @keyframes fireworks-show {
      to {
        transform: scale(1);
      }
    }
    @keyframes slide-in-left {
      0% {
        transform: translateX(-110%);
      }
      72% {
        transform: translateX(8px);
      }
      88% {
        transform: translateX(-3px);
      }
      100% {
        transform: translateX(0);
      }
    }
    @keyframes slide-in-right {
      0% {
        transform: translateX(110%);
      }
      72% {
        transform: translateX(-8px);
      }
      88% {
        transform: translateX(3px);
      }
      100% {
        transform: translateX(0);
      }
    }
    @keyframes slide-in-plane {
      0% {
        transform: translate(110%, 4px);
      }
      72% {
        transform: translate(-8px, -1px);
      }
      88% {
        transform: translate(3px, 1px);
      }
      100% {
        transform: translate(0, 0);
      }
    }
  .mask{
    width: 100%;
    height: 100vh;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 50px;
      height: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue